import React, { ComponentProps } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaSearch } from 'react-icons/fa';

type Props = React.PropsWithoutRef<ComponentProps<typeof Button>>;

const ButtonSubmit = (props: Props) => {
  const { t, i18n } = useTranslation();
  return (
    <Button
      {...props}
      style={{ minWidth: '140px', fontWeight: 500 }}
      variant="success"
      type="submit"
    >
      <FaSearch className="mb-1" />{' '}
      {i18n.language === 'gr' ? t('Αναζήτηση') : t('Search')}
    </Button>
  );
};

export default React.memo(ButtonSubmit);
